import { render } from "./PartnerUpdatesView.vue?vue&type=template&id=974d3ed8"
import script from "./PartnerUpdatesView.vue?vue&type=script&lang=js"
export * from "./PartnerUpdatesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__